module.exports = __webpack_public_path__ + "static/media/ultramax-results-package.061109b5.png";